export default {
  "featureFlag.title": "機能フラグ設定",
  "featureFlag.unlock": "全機能有効化",
  "featureFlag.source.unlock": "強制有効",
  "featureFlag.source.plugins": "プラグイン",
  "featureFlag.source.local": "ローカル設定",
  "featureFlag.source.appsettings": "デフォルト設定",
  "featureFlag.source.default": "既定値",
  "featureFlag.source.unregistered": "未登録"
};
